<template>
    <div class="main">
      <div class="video_top">
        <video class="video_banners"  poster="../../assets/video/banner.png" autoplay muted loop>
              <source src="../../assets/video/banner.mp4" type="video/mp4" class="video_banner">
        </video>
      </div>
      <div class="main_content">
        <!-- 核心技术 -->
        <div class="skill">
          <div class="line">核心技术</div>
          <div class="box_content">
            <div class="box-left">
              <router-link to="/skill"><div class="text_img" @click="goto(page,'skilltop')">
                <img src="../../assets/images/104.png" alt>
                <p class="top_title">视频压缩</p>
                <p class="btm_title">视频数据管理系统是以人工智能为基础、专注于视频及图像处理的创新型产品，通过集成深度学习等多种人工智能技术实现智能压缩存储。</p>
              </div></router-link>
            </div>
            <div class="box-left">
              <router-link to="/skill"><div class="text_img" @click="goto(page,'skillsix')">
                <img src="../../assets/images/105.png" alt>
                <p class="top_title">溯源水印</p>
                <p class="btm_title">客户端将视频转发时，客户端的IP地址、客户编号以及客户单位名称被水印在视频画面，有利于防止视频泄密而不知道泄密源头的弊端。</p>
              </div></router-link>
            </div>
            <div class="box_right">
                <router-link to="/skill"><div class="box_top" @click="goto(page,'skillfive')">
                    <img src="../../assets/images/106.png" alt>
                    <div class="text-right">
                    <p class="top_title" style="margin-top: 0px;">人工智能</p>
                    <p class="btm_title" style="margin-top: 10px; text-indent: 0;">人工智能是一种新的能以人类智能相似的方式做
                        出反应的智能机器，包括机器人、语言识别、图
                        像识别、自然语言处理和专家系统等。</p>
                    </div>
                </div></router-link>
                <div class="box-btm">
                     <Row :gutter="16">
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skillrout')">隐私相机</div> </router-link>
                        </i-col>
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skilltow')">全屏拼接</div></router-link>
                        </i-col>

                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skillfive')">人脸识别</div></router-link>
                        </i-col>
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skillcar')">车牌识别</div></router-link>
                        </i-col>

                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skillpre')">人数统计</div></router-link>
                        </i-col>
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skilltprod')">广告识别</div></router-link>
                        </i-col>
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skillcar')">车流分析</div></router-link>
                        </i-col>
                        <i-col span="6">
                           <router-link to="/skill"> <div class="col_spans" @click="goto(page,'skilllook')">工作状态监控</div></router-link>
                        </i-col>
                    </Row>
                </div>
            </div>
          </div>
        </div>

        <!-- 案例类别 -->
        <div class="skill">
            <div class="line ">行业方案</div>
        </div>
        <div class="blak_box">
            <div class="skill">
                <!-- 第一张 -->
                <div class="pstion_top">
                  <img src="../../assets/images/71.png" alt="">
                  <p>金融</p>
                </div>
                <!-- 第二张 -->
                <div class="pstion_top">
                  <img src="../../assets/images/72.png" alt="">
                  <p>安防</p>
                </div>
                <!-- 第三张 -->
                <div class="pstion_top">
                  <img src="../../assets/images/73.png" alt="">
                  <p>教育</p>
                </div>
                <!-- 第四张 -->
                <div class="pstion_top">
                  <img src="../../assets/images/74.png" alt="">
                  <p>政府</p>
                </div>
                <!-- 第五张 -->
                <div class="pstion_top">
                  <img src="../../assets/images/75.png" alt="">
                  <p>能源</p>
                </div>
            </div>
        </div>


        <!-- 核心产品 -->
        <div class="skill">
            <div class="line ">核心产品</div>

            <div class="height_img">
                <div class="btm_img">
                    <img src="../../assets/images/107.png" alt="">
                    <p style="padding-top: 20px;">视频智能处理器系列（vdms-t-1）</p>
                </div>
                <div class="btm_img">
                    <img src="../../assets/images/81.png" alt="">
                    <p style="padding-top: 104px;">VDMS视频处理服务器</p>
                </div>
                
             </div>
        </div>
        
        <!-- 下方司马大大 -->
        <div class="bottom_logo">
            <img src="../../assets/images/77.png" alt="">
            <div class="skill">
                <p>司马达拓更多详情</p>
                <router-link to="/about" class="href_rot">了解更多</router-link>
            </div>
        </div>

      </div>
    </div>
</template>

<script>
export default {
  data() {
        return {
            page: ''
        }
    },
  beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
  methods: {
    goto(page,selectId) {
        var path = page;
        var selectId = selectId;
        localStorage.setItem("toId",selectId);
        this.$router.push({path: path});
    },
  },
  

  mounted() {
    if(status === JIN_RONG) {
            Routers.push('solve'+'/'+Jin)
        }
      
    router.afterEach((to, from, next) => {
        window.scrollTo(0,0);
    })
  }

  

};
</script>

<style>
/* 内容总视图 */
.main {
  width: 100%;
  background: #ffffff;
  font-family: "MicrosoftYaHei";
}
/* 上方视频样式 */
.video_top {
  width: 100%;
  height: 1080px;
  background: #34507c;
}

.video_banner {
  width: 100%;
  height: 100%;
}

.video_banners {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
video::-webkit-media-controls {
  display: none !important;
}
/* 首页内容 */
.main_content {
  width: 100%;
}

/* 技术 */
.skill {
  width: 1200px;
  /* height: 743px; */
  margin: 0 auto;
}

/* 分割线 */
.main_content .line {
  font-size: 35px;
  text-align: center;
  color: #000000;
  width: 1000px;
  position: relative;
  margin-left: 100px;
  margin-top: 103px;
  padding: 0;
}
.line::before {
  content: "";
  position: absolute;
  display: block;
  width: 370px;
  border-top: 1px solid #000000;
  top: 26px;
}
.line::after {
  content: "";
  position: absolute;
  display: block;
  width: 370px;
  border-top: 1px solid #000000;
  right: 0;
  top: 26px;
}

/* 中间框的内容 */
.box_content {
  width: 1100px;
  height: 527px;
  margin: 0 auto;
  margin-top: 70px;
  border: 2px solid #000000;
  box-shadow: inset 0px 0px 6px 1px #000;
  color: #333333;
}

/* 275, 275, 550,170 */
/* 技术左侧第一个框 */
.box-left {
  width: 275px;
  height: 100%;
  border-right: 3px solid #000000;
  float: left;
}

.text_img {
  width: 222px;
  padding-top: 48px;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
}

.text_img:hover {
  text-shadow: 0px 0px 1px #333333;
}

.top_title {
  color: #333333;
  font-size: 24px;
  margin-top: 25px;
}

.btm_title {
  font-size: 18px;
  text-align: left;
  margin-top: 30px;
  text-indent: 2em;
  color: #333333;
}

.box_right {
    width: 546px;
    float: right;
}
.box_top {
    padding-top: 25px;
    padding-left: 20px;
    height: 170px;
    border-bottom: 3px solid #000000;
}

.text-right {
    width: 388px;
    float: right;
    /* margin-right: 20px; */
}

.text-right:hover {
  text-shadow: 0px 0px 1px #333333;
}
.active {
  text-shadow: 0px 0px 2px #333333;
}

.col_spans{
    color: #ffffff;
    width: 116px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    margin-top: 83px;
    background: #262d33;
    margin-right: -20px;
    cursor: pointer;
}
.col_spans:hover {
  box-shadow: 1px 1px 4px #262d33;
}

.box-btm {
    margin: 0 auto;
}

.box-btm .ivu-col {
  width: 123px;
  margin-left: 15px;
  margin-right: -5px;
}

/* 案例类型图片 */
.blak_box {
  margin-top: 89px;
  height: 475px;
  background: #36373A;
}

.pstion_top {
  width: 20%;
  float: left;
  text-align: center;
  margin-top: 95px;
}
.pstion_top p {
  font-size: 28px;
  color: #ffffff;
  margin-top: 40px;
}
.pstion_top:nth-child(3) p {
  margin-top: 64px;
}
.blak_box .pstion_top:nth-child(3) {
  margin-top: 125px;
}


/* 核心产品卡片 */

.height_img {
    margin-top: 90px;
    height: 600px;
}
.height_img .btm_img {
    width: 570px;
    height: 470px;
    border: 3px solid #000000;
    padding: 20px;
}
.height_img .btm_img:nth-child(1) {
    float: left;
}
.height_img .btm_img:nth-child(2) {
    float: right;
    padding-top: 185px;
}
.btm_img img {
  width: 100%;
}

.height_img .btm_img p {
  font-size: 18px;
  color: #333333;
  /* width: 195px; */
  text-align: center;
  margin: 0 auto;
}

/* 下方logo */
.bottom_logo {
    /* margin-top: 100px; */
    width: 100%;
    height: 513px;
    position: relative;
    background: #202125;
}
.bottom_logo img {
    width: 100%; 
    height: 100%;
}
.bottom_logo p {
    font-size: 80px;
    color: #ffffff;
    position: absolute;
    top: 50%;
    margin-top: -80px;
    left: 50%;
    margin-left: -280px;
}

/* 了解更多路由跳转 */
.href_rot {
    font-size: 30px;
    color: #dddddd;
    display: block;
    width: 180px;
    height: 54px;
    border: 1px solid #dddddd;
    text-align: center;
    line-height: 50px;
    position: absolute;
    top: 50%;
    margin-top: 120px;
    left: 50%;
    margin-left: -60px;
    border-radius: 8px;
}

/* 案例类别蒙层 */
.big_opcity {
    width: 100%;
    height: 422px;
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
}
.big_opcity:hover { 
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/home/home.vue